import AlertModal, { ALERT_VARIANT } from "./alertModal/AlertModal";

/**
 * SessionErrorModals - presentational host for the server-not-responding and RTMS error modals.
 * All state and reset/restart transitions live in useSummarizationController; this component
 * only renders and forwards the user's choice. Spread the controller's `errorModals` bundle in;
 * `context` (MAIN_CONTEXT) picks the summarize or transcribe copy.
 */
const SessionErrorModals = ({
  context,
  isServerErrorModalOpen,
  isRtmsErrorModalOpen,
  rtmsErrorType,
  onDismissServerError,
  onCancelRtmsError,
  onRestartRtmsError,
}) => (
  <>
    <AlertModal variant={ALERT_VARIANT.SERVER_NOT_RESPONDING} isOpen={isServerErrorModalOpen} onClose={onDismissServerError} context={context} />
    {rtmsErrorType && (
      <AlertModal
        variant={ALERT_VARIANT.RTMS_ERROR}
        isOpen={isRtmsErrorModalOpen}
        errorType={rtmsErrorType}
        onCancel={onCancelRtmsError}
        onRestart={onRestartRtmsError}
        context={context}
      />
    )}
  </>
);

export default SessionErrorModals;
